import ExcelJS from 'exceljs';
import file from '../../../assets/sheets/acidente.xlsx'; // Your imported Excel file
import { replace } from 'utils/common/replaceIdsByValues';
import { format } from 'date-fns';

const AcidenteEditor = () => {

    const handleEditAcidentColumns = async (data, users) => {
        try {
            const updatedData = replace(data, users)

            const response = await fetch(file);
            const arrayBuffer = await response.arrayBuffer();
            const workbook = new ExcelJS.Workbook();
            await workbook.xlsx.load(arrayBuffer);
            const worksheet = workbook.getWorksheet(1);

            const row16 = worksheet.getRow(16);
            const cellC16 = row16.getCell(4);
            cellC16.value = format(new Date(updatedData.created_at), 'yyyy-MM-dd')

            const row17 = worksheet.getRow(17);
            const cellC17 = row17.getCell(4);
            const cellG17 = row17.getCell(7);
            cellC17.value = format(new Date(updatedData.created_at), 'HH:mm');
            cellG17.value = updatedData.resposaveis

            const row18 = worksheet.getRow(18);
            const cellC18 = row18.getCell(4);
            cellC18.value = '- -';//Referencia

            const row20 = worksheet.getRow(20);
            const cellC20 = row20.getCell(3);
            cellC20.value = updatedData.name;

            const row21 = worksheet.getRow(21);
            const cellC21 = row21.getCell(3);
            const cellL21 = row21.getCell(12);
            const cellM21 = row21.getCell(13);

            cellC21.value = '- -'; //Posição do remetente
            cellL21.value = updatedData.com_arquivada === 0 ? 'Não' : 'Sim'
            cellM21.value = updatedData.com_arquivada_data == null ? '- -' : format(new Date(updatedData.com_arquivada_data), 'yyyy-MM-dd');

            const row22 = worksheet.getRow(22);
            const cellL22 = row22.getCell(12);
            const cellM22 = row22.getCell(13);
            const cellC22 = row22.getCell(3);
            cellC22.value = updatedData.local_reporter;
            cellM22.value = updatedData.com_arquivada_cta === 0 ? 'Não' : 'Sim';
            cellL22.value = updatedData.com_arquivada_cta_data == null ? '- -' : format(new Date(updatedData.com_arquivada_data), 'yyyy-MM-dd');

            const row23 = worksheet.getRow(23);
            const cellC23 = row23.getCell(3);
            cellC23.value = '- -';//Remetente Telefone

            const row24 = worksheet.getRow(24);
            const cellC24 = row24.getCell(3);
            const cellL24 = row24.getCell(12);
            cellC24.value = '- -';//Remetente email
            cellL24.value = updatedData.severidade

            const row25 = worksheet.getRow(25);
            const cellC25 = row25.getCell(4);
            cellC25.value = '- -';//Remetente assinatura

            const row28 = worksheet.getRow(28);
            const cellC28 = row28.getCell(2);
            const cellL28 = row28.getCell(12);
            cellC28.value = updatedData.circunstancias
            cellL28.value = '- -';

            const row27 = worksheet.getRow(27);
            const cellL27 = row27.getCell(12);
            cellL27.value = format(new Date(updatedData.dataAcontecimento), 'yyyy-MM-dd')

            const row29 = worksheet.getRow(29);
            const cellL29 = row29.getCell(12);
            cellL29.value = updatedData.local

            const row31 = worksheet.getRow(31);
            const cellL31 = row31.getCell(12);
            cellL31.value = '- -'

            const row32 = worksheet.getRow(32);
            const cellL32 = row32.getCell(12);
            cellL32.value = '- -'

            const row33 = worksheet.getRow(33);
            const cellL33 = row33.getCell(12);
            cellL33.value = '- -'

            const row34 = worksheet.getRow(34);
            const cellL34 = row34.getCell(12);
            cellL34.value = '- -'

            const row35 = worksheet.getRow(35);
            const cellL35 = row35.getCell(12);
            cellL35.value = '- -'

            const row36 = worksheet.getRow(36);
            const cellL36 = row36.getCell(12);
            cellL36.value = '- -'

            const row38 = worksheet.getRow(38);
            const cellL38 = row38.getCell(12);
            cellL38.value = updatedData.autores

            const row39 = worksheet.getRow(39);
            const cellC39 = row39.getCell(3);
            const cellD39 = row39.getCell(4);
            const cellE39 = row39.getCell(6);
            cellC39.value = updatedData.terceiros_fatalidades + updatedData.terceiros_feridos
            cellD39.value = updatedData.terceiros_feridos
            cellE39.value = updatedData.terceiros_fatalidades

            const row40 = worksheet.getRow(40);
            const cellC40 = row40.getCell(3);
            const cellD40 = row40.getCell(4);
            const cellE40 = row40.getCell(6);
            cellC40.value = updatedData.contratados_fatalidades + updatedData.contratados_feridos
            cellD40.value = updatedData.contratados_feridos
            cellE40.value = updatedData.contratados_fatalidades

            const row41 = worksheet.getRow(41);
            const cellC41 = row41.getCell(3);
            const cellD41 = row41.getCell(4);
            const cellE41 = row41.getCell(6);
            cellC41.value = updatedData.samcol_fatalidades + updatedData.samcol_feridos
            cellD41.value = updatedData.samcol_feridos
            cellE41.value = updatedData.samcol_fatalidades

            const row45 = worksheet.getRow(45);
            const cellL45 = row45.getCell(8);
            cellL45.value = updatedData.medidas_imediatas

            const row47 = worksheet.getRow(47);
            const cellB47 = row47.getCell(2);
            cellB47.value = updatedData.dm_samcol ?? 0

            const row50 = worksheet.getRow(50);
            const cellB50 = row50.getCell(2);
            cellB50.value = updatedData.dm_terceiros ?? 0

            const row53 = worksheet.getRow(53);
            const cellB53 = row53.getCell(2);
            cellB53.value = updatedData.dm_contratados ?? 0

            const row57 = worksheet.getRow(57);
            const cellB57 = row57.getCell(2);
            cellB57.value = updatedData.di_samcol ?? 0

            const row60 = worksheet.getRow(60);
            const cellB60 = row60.getCell(2);
            cellB60.value = updatedData.di_outros ?? 0

            const row63 = worksheet.getRow(63);
            const cellB63 = row63.getCell(2);
            cellB63.value = updatedData.di_imprensa ?? 0

            const row68 = worksheet.getRow(68);
            const cellB68 = row68.getCell(4);
            cellB68.value = updatedData.Jap

            const row69 = worksheet.getRow(69);
            const cellB69 = row69.getCell(4);
            cellB69.value = updatedData.Jf

            const row70 = worksheet.getRow(70);
            const cellB70 = row70.getCell(4);
            cellB70.value = updatedData.Ji

            const row67 = worksheet.getRow(67);
            const cellB67 = row67.getCell(4);
            cellB67.value = updatedData.Jae

            const row71 = worksheet.getRow(71);
            const cellB71 = row71.getCell(4);
            cellB71.value = updatedData.Aap

            const row73 = worksheet.getRow(73);
            const cellB73 = row73.getCell(4);
            cellB73.value = updatedData.Aap

            const row74 = worksheet.getRow(74);
            const cellB74 = row74.getCell(4);
            cellB74.value = updatedData.Af

            const row75 = worksheet.getRow(75);
            const cellB75 = row75.getCell(4);
            cellB75.value = updatedData.Ai

            const row76 = worksheet.getRow(76);
            const cellB76 = row76.getCell(4);
            cellB76.value = updatedData.Aae

            const cellH67 = row67.getCell(8);
            cellH67.value = updatedData.causas_preliminares

            const row80 = worksheet.getRow(80);
            const cellB80 = row80.getCell(7);
            cellB80.value = '- -'//Comentarios

            row20.commit();
            row32.commit();

            const editedBuffer = await workbook.xlsx.writeBuffer();

            const blob = new Blob([editedBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = `${updatedData.local}_${format(new Date(updatedData.dataAcontecimento), 'yyyy-MM-dd')}_acidente.xlsx`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);

        } catch (error) {
            console.error('Error editing Excel file:', error);
        }
    };

    return { handleEditAcidentColumns }
};

export default AcidenteEditor;
